import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=759a0095&"
import script from "./StudentDetails.vue?vue&type=script&lang=ts&"
export * from "./StudentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports